// ?use_ios_ui — iOS ManualPlacementViewModel.returnToWebApp's round trip:
// back to the storefront, with the outcome in the fragment.

export function buildArCompleteUrl({
  returnURL,
  success,
  wheels,
}: {
  returnURL: URL
  success: boolean
  wheels: number
}): string {
  const url = new URL(returnURL.toString())
  url.hash = `ar-complete=true&success=${success}&wheels=${wheels}`
  return url.toString()
}
